import { Flex } from 'components';
import { Blocks } from 'components/Blocks';
import styled from 'styled-components';
import { useAssessmentContext } from 'contexts/AssessmentContext';

const Wrapper = styled(Flex)`
  position: relative;
`;

const Legend = styled(Flex)`
  position: absolute;
  left: 50%;
`;

interface IAssessmentBlocksProps {
  showLegend?: boolean;
}

export const AssessmentBlocks: React.FC<IAssessmentBlocksProps> = ({
  showLegend
}) => {
  const { selectedBlock, selectedAssessments, setSelectedBlock } =
    useAssessmentContext();

  return (
    <Wrapper>
      {showLegend && <Legend>Legend</Legend>}
      {selectedAssessments[0] && (
        <Blocks
          practice={selectedAssessments[0].practice}
          selectedBlock={selectedBlock}
          checkButton={false}
          onBlockClick={(block) => {
            setSelectedBlock(block);
          }}
          width={110}
          height={80}
          fontVariant="body2"
          themeFontVariant="body"
          increasing={false}
          showScores
        />
      )}
    </Wrapper>
  );
};
